/* eslint-disable eqeqeq */
import { createSlice } from '@reduxjs/toolkit';
const sidebarWidth = localStorage.getItem('sidebar-width') ? localStorage.getItem('sidebar-width') : "240px";
const sidebarMinimumWidth = 60;

let sidebar_show_lsstate = localStorage.getItem('rs-sidebar');//sidebar show local storage state
const initialState = localStorage.getItem('rs-sidebar') ? {
  show: sidebar_show_lsstate == null ? true : sidebar_show_lsstate == 'true' ? true : false,
  sidebarWidth: sidebarWidth,
  sidebarMinimumWidth: sidebarMinimumWidth,
  toggleNavbar: false,
  showDocSearch: false,
  isLargeDevice: false,
} : {
  show: sidebar_show_lsstate == null ? true : sidebar_show_lsstate == 'true' ? true : false, sidebarWidth: sidebarWidth, sidebarMinimumWidth: sidebarMinimumWidth,
  toggleNavbar: false,
  showDocSearch: false,
  isLargeDevice: false,
};
export const RS_Sidebar = createSlice({
  name: 'rs-sidebar',
  initialState,
  reducers: {
    handleShow: (state) => {
      localStorage.setItem('rs-sidebar', true) //localStorage coerce this boolean value into string, hence, after getting it into memory, remember to think it as string and use string comparison with 'true' or 'false'
      state.show = true;
    },
    handleClose: (state) => {
      localStorage.setItem('rs-sidebar', false) //localStorage coerce this boolean value into string, hence, after getting it into memory, remember to think it as string and use string comparison with 'true' or 'false'
      state.show = false;
    },
    setSidebarWidth: (state, action) => {
      localStorage.setItem('sidebar-width', action.payload)
      state.sidebarWidth = action.payload
    },
    handleToggleNavbar: (state, action) => {
      state.toggleNavbar = action.payload;
    },
    handleDocSearchModal: (state, action) => {
      state.showDocSearch = action.payload;
    },
    setLargeDevice: (state, action) => {
      state.isLargeDevice = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const { handleShow, handleClose, setSidebarWidth, handleToggleNavbar, handleDocSearchModal, setLargeDevice } = RS_Sidebar.actions;

export default RS_Sidebar.reducer;